module.exports = __webpack_public_path__ + "static/img/36.ad658aec.jpeg";